export const dataCards = [
  { key: 101, data: 'Empleado sin proyecto asignado' },
  { key: 102, data: 'Empleado con ausencias programadas en los proximos días' },
  { key: 103, data: 'Empleado con proyecto a finalizar en 1 mes' },
  { key: 104, data: 'Empleado sin feedback de desempeño actual' },
  { key: 105, data: 'Empleado con plan de crecimiento a cumplirse en 1 mes' },
  { key: 201, data: 'Cliente sin proyectos' },
  { key: 202, data: 'Cliente con fecha próxima a finalizar la relación' },
  { key: 301, data: 'Proyecto sin miembros asginados' },
  { key: 302, data: 'Proyecto con fecha próxima a finalizar' },
];
